import PushesViewState from './pushesViewContext/pushesViewState/PushesViewState';
import Controls from './components/Controls/Controls';
import Info from './components/Info/Info';
import ModalWindows from './components/ModalWindows/ModalWindows';
import React from 'react';
import style from './PushesView.module.scss';

const PushesView: React.FC = () => {
	return (
		<PushesViewState>
			<div className={style.container}>
				<Info />
				<Controls />
				<ModalWindows />
			</div>
		</PushesViewState>
	);
};

export default PushesView;
